import { Permission } from "~/types";
import { PermissionNames } from "~/configs/permission_names";
import { useAuthStore } from "~/stores/auth";

export const isUserPermitted = function (
  permissionName?: PermissionNames,
): boolean {
  if (!permissionName) return true;
  const userPermissions = useAuthStore().permissions;
  if (!userPermissions || !permissionName) return false;
  return userPermissions.some((p: Permission) => {
    return p.name === permissionName.toString();
  });
};
